// bao migrate skip
import TabPage from "./../factories/tab-page";
import "./../services/bao-router";
import "./../services/finito-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoMenu from "./../services/bao-menu";
import Guid from "./../factories/guid";
import baoRouter from "./../services/bao-router";
import SubscriptionViewModel from "./../factories/subscription-view-model";
import finitoService from "./../services/finito-service";
class BriefingBook extends SubscriptionViewModel {
    FormName: KnockoutObservable<string> = ko.observable();
    ReportShortTitle: KnockoutObservable<string> = ko.observable();
    ReportTitle: KnockoutObservable<string> = ko.observable();
    BriefingBooks: KnockoutObservableArray<any> = ko.observableArray([]);
    SelectedBriefingBookId: KnockoutObservable<string> = ko.observable();
    ShowAll: KnockoutObservable<boolean> = ko.observable();
    ShowOnlyUnread: KnockoutObservable<boolean> = ko.observable();
    MeAsAttendee: KnockoutObservable<boolean> = ko.observable();
    MeAsRecipient: KnockoutObservable<boolean> = ko.observable();
    MeAsCreator: KnockoutObservable<boolean> = ko.observable();
    Briefings: KnockoutObservableArray<any> = ko.observableArray([]);
    PageSize: KnockoutObservable<number> = ko.observable(20);
    PageIndex: KnockoutObservable<number> = ko.observable(0);
    Sorting: KnockoutObservableArray<any> = ko.observableArray();
    Selection: KnockoutObservableArray<any> = ko.observableArray();
    TotalRows: KnockoutObservable<number> = ko.observable(0);
    CustomFilter: KnockoutObservable<any> = ko.observable({});
    IsFirstLoaded: KnockoutObservable<boolean> = ko.observable(false);
    ShiftbooksPermissions: any;
    IsFavorite: KnockoutObservable<boolean> = ko.observable(false);
    Color: string = "text-secondary";
    Icon: string = "fal fa-briefcase";
    Sort: number = 45;
    constructor(tabPage: TabPage) {
        super(tabPage);
        this.SettingsKeyPermission("ShiftbookSave");
        this.SettingsKeyPermissionApplicationId(window.FinitoApplicationId);
        this.subscribe(this.PageIndex, () => {
            if (this.IsFirstLoaded()) {
                this.RefreshBriefings();
            }
        });
        this.subscribe(this.SelectedBriefingBookId, () => {
            this.SetPermissions();
            this.RefreshBriefings();
            this.isQuickStartModuleActive();
            baoRouter.setHash("briefingbook/" + this.SelectedBriefingBookId());
            this.SettingsUrl(this.SelectedBriefingBookId() ? 'Shiftbook/' + this.SelectedBriefingBookId() : null);
          
        });
        this.subscribe(this.TotalRows, () => {
            this.toggleButtons();
        });
        this.subscribe(this.TabPage.UrlData, (value) => {
            if (value.briefingbookid && this.SelectedBriefingBookId() != value.briefingbookid && this.BriefingBooks().some(b => ko.unwrap(b.ShiftbookId) == value.briefingbookid)) {
                this.SelectedBriefingBookId(value.briefingbookid)
            }
        });
    }
    link = (index, briefingModel) => {
        let linkHash = 'briefing/' + briefingModel.InstructionId();
        baoRouter.setHash(linkHash);
    };
    init = () => {
        this.TabPage.IsLoading(true);
        return $.when(this.getUserProfile(), this.getBriefingBooks()).then(() => {
            return this.getReport()
                .then(() => {
                this.toggleButtons();
                this.SetPermissions();
            });
        });
    };
    changeFavoriteStatus = () => {
        var promise;
        if (this.IsFavorite()) {
            promise = this.removeQuickStartModuleWebUrl();
        }
        else {
            promise = this.addQuickStartModule();
        }
        promise.then(() => { Bao.raiseEvent('QuickStartModules:refresh', null); });
    };
    addQuickStartModule = () => {
        this.TabPage.IsLoading(true);
        let selectedBriefingBook = this.BriefingBooks()
            .filter(e => e.PrimaryKeyValue === this.SelectedBriefingBookId());
        let briefingBookName = selectedBriefingBook[0].Name;
        let briefingBookCssClass = selectedBriefingBook[0] ? selectedBriefingBook[0].CssClass : undefined;
        return Bao.post("StartModule/AddQuickStartModule", JSON.stringify({
            caption1: briefingBookName,
            caption2: briefingBookName,
            caption3: briefingBookName,
            caption4: briefingBookName,
            caption5: briefingBookName,
            webUrl: this.GetBriefingBookDeepLink(),
            color: this.Color,
            icon: (typeof briefingBookCssClass != 'undefined' && briefingBookCssClass) ? briefingBookCssClass : this.Icon,
            sort: this.Sort
        })).done(result => {
            if (result) {
                this.IsFavorite(true);
            }
            this.TabPage.IsLoading(false);
        });
    };
    isQuickStartModuleActive = () => {
        return Bao.post("StartModule/IsQuickStartModuleActive", JSON.stringify({
            webUrl: this.GetBriefingBookDeepLink()
        })).done(result => {
            this.IsFavorite(result);
        });
    };
    removeQuickStartModuleWebUrl = () => {
        this.TabPage.IsLoading(true);
        return Bao.post("StartModule/RemoveQuickStartModuleByWebUrl", JSON.stringify({
            webUrl: this.GetBriefingBookDeepLink()
        })).done(result => {
            if (result) {
                this.IsFavorite(false);
            }
            this.TabPage.IsLoading(false);
        });
    };
    GetBriefingBookDeepLink() {
        return "#/BriefingBook/" + this.SelectedBriefingBookId();
    }
    loaded = () => {
        let def = $.Deferred();
        this.registerMenuClick();
        this.toggleButtons();
        Bao.bindEvent('briefings:refresh', (value) => {
            this.refresh();
        });
        Bao.bindEvent('FavoriteIcon:refresh', (value) => {
            this.IsFavorite(!this.IsFavorite());
        });
        this.subscribe(this.Selection, () => {
            this.toggleButtons();
        });
        this.subscribe(this.Sorting, () => {
            this.RefreshBriefings();
        });
        this.subscribe(this.CustomFilter, () => {
            this.ResetPageIndexAndRefresh();
        });
        this.subscribe(this.ShowOnlyUnread, () => {
            this.ResetPageIndexAndRefresh();
        });
        this.subscribe(this.MeAsAttendee, () => {
            this.ResetPageIndexAndRefresh();
        });
        this.subscribe(this.MeAsRecipient, () => {
            this.ResetPageIndexAndRefresh();
        });
        this.subscribe(this.MeAsCreator, () => {
            this.ResetPageIndexAndRefresh();
        });
        this.subscribe(this.PageSize, () => {
            this.ResetPageIndexAndRefresh();
        });       
        def.resolve();
        return def.promise();
    };
    ToHashObject = (customFilter) => {
        let returnValue = [];
        for (let f in customFilter) {
            returnValue.push({ Key: f, Value: ko.unwrap(customFilter[f]) });
        }
        return returnValue;
    };
    getUserProfile = () => {
        return Bao.post('BriefingBook/LoadUserProfile', JSON.stringify({})).then((result) => {
            this.ShowOnlyUnread(result.showOnlyUnread === "true");
            this.MeAsAttendee(result.meAsAttendee === "true");
            this.MeAsRecipient(result.meAsRecipient === "true");
            this.MeAsCreator(result.meAsCreator === "true");
        });
    };
    getBriefingBooks = () => {
        return Bao.post('Shiftbook/GetBriefingBooksForCurrentUser')
            .then(serverResult => {
            if (serverResult && serverResult.BooksForCurrentUser && serverResult.BooksForCurrentUser.length > 0) {
                this.BriefingBooks(serverResult.BooksForCurrentUser);
                this.ShiftbooksPermissions = serverResult.ShiftbooksPermissions;
            }
            else {
                new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgUserHasNoAssignedBriefingBooks"), "info");
                this.TabPage.IsLoading(false);
            }
            let briefingBookId = baoRouter.getRouteValue("briefingbookid", (<any>this.TabPage));
            if (briefingBookId && serverResult.BooksForCurrentUser.filter(t => t.ShiftbookId === briefingBookId).length > 0) {
                this.SelectedBriefingBookId(briefingBookId);
            }
        });
    };
    registerMenuClick = () => {
        BaoMenu.registerEvent((btn) => {
            if (this.TabPage != null && this.TabPage.IsActiveTab != null && this.TabPage.IsActiveTab() === true) {
                let methodString = btn.ActionKey().substr(this.FormName().length);
                if (methodString) {
                    methodString = methodString.toLowerCase();
                    if ($.isFunction(this[methodString])) {
                        this[methodString]();
                    }
                }
            }
        });
    };
    getReport = () => {
        return Bao.post('BriefingBook/GetBriefingBookModel', JSON.stringify({})).then((result) => {
            ko.map.fromJS(result.Model, this);
            this.TabPage.Title(this.ReportShortTitle());
            (<any>this.TabPage).ToolTip(this.ReportTitle());
        });
    };
    RefreshBriefings() {
        this.TabPage.IsLoading(true);
        this.getBriefings()
            .then(() => {
            this.TabPage.IsLoading(false);
        });
    }
    getBriefings = () => {
        if (!this.SelectedBriefingBookId())
            return;
        let customFilter = this.ToHashObject(ko.unwrap(this.CustomFilter));
        return Bao.post('BriefingBook/GetAll', JSON.stringify({
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: this.Sorting(),
            searchFilter: {
                ShowAll: this.ShowAll(),
                ShowOnlyUnread: this.ShowOnlyUnread(),
                MeAsAttendee: this.MeAsAttendee(),
                MeAsRecipient: this.MeAsRecipient(),
                MeAsCreator: this.MeAsCreator(),
                ShiftbookId: this.SelectedBriefingBookId()
            },
            customfilter: customFilter
        })).then((result) => {
            ko.map.fromJS(result.Models, this.Briefings);
            this.TotalRows(result.TotalRows);
            this.IsFirstLoaded(true);
        });
    };
    toggleButtons = () => {
        if (this.FormName) {
            if (this.SelectedBriefingBookId()) {
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'New', Enabled: true, Context: this.TabPage.Context() });
            }
            else {
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'New', Enabled: false, Context: this.TabPage.Context() });
            }
            if (this.TotalRows && this.TotalRows() < 1) {
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Edit', Enabled: false, Context: this.TabPage.Context() });
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Delete', Enabled: false, Context: this.TabPage.Context() });
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Read', Enabled: false, Context: this.TabPage.Context() });
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Print', Enabled: false, Context: this.TabPage.Context() });
            }
            else {
                var selection = this.Selection.peek();
                if (selection && selection.length > 0) {
                    BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Edit', Enabled: true, Context: this.TabPage.Context() });
                    BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Delete', Enabled: true, Context: this.TabPage.Context() });
                    BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Read', Enabled: !selection[0].IsRead.peek() && selection[0].CanMarkRead() && !selection[0].IsClosed.peek(), Context: this.TabPage.Context() });
                    BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Print', Enabled: true, Context: this.TabPage.Context() });
                }
                else {
                    BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Edit', Enabled: false, Context: this.TabPage.Context() });
                    BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Delete', Enabled: false, Context: this.TabPage.Context() });
                    BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Read', Enabled: false, Context: this.TabPage.Context() });
                }
            }
        }
    };
    ["new"] = () => {
        var linkHash = 'briefing/' + Guid() + '/' + this.SelectedBriefingBookId();
        baoRouter.setHash(linkHash);
    };
    edit = () => {
        var selection = this.Selection();
        if (selection && selection.length > 0) {
            baoRouter.setHash('briefing/' + selection[0].InstructionId());
        }
    };
    canFinish = (instruction) => {
        if (instruction) {
            if (!instruction.IsClosed.peek()) {
                if (instruction.InstructionTypeId.peek() === finitoService.InstructionTypeIds.ValidToFinished
                    || instruction.InstructionTypeId.peek() === finitoService.InstructionTypeIds.ValidFromToOrFinished) {
                    return true;
                }
            }
        }
        return false;
    };
    read = () => {
        var selection = this.Selection();
        if (selection && selection.length > 0) {
            var dialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.InstructionReadQuestion), 'yesno');
            dialog.DialogResult.subscribe(shouldRead => {
                if (shouldRead) {
                    this.TabPage.IsLoading(true);
                    Bao.post('Instruction/Read', JSON.stringify({
                        instructionIds: [selection[0].InstructionId()]
                    })).then(read => {
                        if (read > 0) {
                            this.refresh();
                        }
                        this.TabPage.IsLoading(false);
                    });
                }
            });
        }
    };
    ["delete"] = () => {
        var selection = this.Selection();
        if (selection && selection.length > 0) {
            var dialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.InstructionDeleteQuestion), 'yesno');
            dialog.DialogResult.subscribe(canDelete => {
                if (canDelete) {
                    this.TabPage.IsLoading(true);
                    return Bao.post('Instruction/Delete', JSON.stringify({
                        instructionIds: [selection[0].InstructionId()]
                    })).then(deleted => {
                        this.Selection([]);
                        if (deleted > 0) {
                            this.showAlert(finitoService.MessageKeys.InstructionDeleteSuccessful);
                            this.refresh();
                        }
                        else {
                            this.showAlert(finitoService.MessageKeys.InstructionDeleteError, 'danger');
                        }
                        this.TabPage.IsLoading(false);
                    });
                }
            });
        }
    };
    refresh = () => {
        this.RefreshBriefings();
    };
    // Drucken
    print() {
        console.log("print0");
        this.TabPage.IsLoading(true);
        Bao.post("BriefingBook/Print", JSON.stringify({
            BriefingbookId: this.SelectedBriefingBookId()
        }), (result) => {
            console.log("print1");
            this.TabPage.IsLoading(false);
            if (result.Result == true) {
                baoRouter.setHash("document/" + result.Message);
            }
            else {
                new BaoDialogViewModel(Bao.Session.ApplicationName, result.Message, "info");
            }
        });
    }
    ;
    /**
     * Get the permissions object for the current selected BriefingBook
     * */
    GetCurrentBooksPermissions() {
        if (this.SelectedBriefingBookId() && this.ShiftbooksPermissions) {
            return this.ShiftbooksPermissions[this.SelectedBriefingBookId()];
        }
        return null;
    }
    /**
     * Shows/Hides toolbar buttons for the current BriefingBook permissions (RoleShiftbooks)
     * */
    SetPermissions() {
        let permissions = this.GetCurrentBooksPermissions();
        if (!permissions)
            return;
        for (let actionKey in permissions) {
            BaoMenu.permissionVisible({ ActionKey: actionKey, Context: this.TabPage.Context(), Visible: permissions[actionKey] });
            if (actionKey === "BriefingReportShowAll") {
                this.ShowAll(permissions[actionKey]);
            }
        }
    }
    ResetPageIndexAndRefresh() {
        if (this.PageIndex() === 0) {
            this.RefreshBriefings();
        }
        else {
            this.PageIndex(0);
        }
    }
    ;
}
export default BriefingBook;